import { render, staticRenderFns } from "./allocationTask.vue?vue&type=template&id=721b4f7c&"
import script from "./allocationTask.vue?vue&type=script&lang=js&"
export * from "./allocationTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports